import { get } from 'utils/fetch/fetchHelper'
interface Option {
  action: string
  actionName: string
}
export interface Action {
  description: string
  order: number
  options: Array<Option>
}
export interface ActionsData {
  actions?: Array<Action>
}

type TabAction =
  | 'MARK_AS_SYNCED'
  | 'MARK_AS_PAID'
  | 'PAYOUT'
  | 'UPLOAD_INVOICE'
  | 'CONFIRM'
  | 'APPROVE'

export const fetchActionsForUser = (
  userId: string,
  tabs: { [key in TabAction]: boolean },
) => {
  const actionTypes = encodeURIComponent(
    Object.entries(tabs)
      .filter(([_, value]) => !!value)
      .map(([key]) => key)
      .join(','),
  )

  return get<ActionsData>(
    `/reports/actions?userId=${userId}&actionTypes=${actionTypes}`,
  )
}
